import { z } from "zod";
const envSchema = z.strictObject({
    VUE_APP_HOST: z.string(),
    VUE_APP_HOST_API: z.string(),
    VUE_APP_EMAIL: z.string().email(),
    VUE_APP_TOKEN_DEFAULT: z.string(),
    VUE_APP_CURRENCY_DEFAULT: z.string(),
    VUE_APP_SCAN_BASE_URL: z.string(),
    VUE_APP_BSCSCAN_BASE_URL: z.string(),
    VUE_APP_ANALYTICS_GOOGLE_KEY: z.string(),
    VUE_APP_ANALYTICS_YANDEX_KEY: z.coerce.number(), // числовой ключ
    VUE_APP_WEBSOCKET_ENABLED: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_WEBSOCKET_HOST: z.string(),
    VUE_APP_DEFAULT_LOCALE: z.string(),
    VUE_APP_SUPPORTED_LOCALES: z.string().transform(str => str.split(",")),
    VUE_APP_SHOW_TESTNET: z.preprocess(val => val === "1", z.boolean()),
    VUE_APP_UNITS_SYSTEM: z.enum(["metric", "imperial"]), // примеры систем единиц
    VUE_APP_POLICY: z.string(),
    VUE_APP_ALLOWED_VIDEO_SERVICES: z.string().transform(str => str.split(",")),
    VUE_APP_SUMSUB_CHECK_LEVEL: z.string(),
    VUE_APP_CARROT_ENABLED: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_AUT_WITHDRAWAL_ENABLED: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_AUT_MNEMONIC: z.string(),
    VUE_APP_THEME_DEFAULT: z.enum(["light", "dark"]),
    VUE_APP_AVAILABLE_THEMES: z.enum(["light", "dark"]).optional(),
    VUE_APP_AUTODEPLOY_PROJECT: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_CAPITAL_ASSET_TYPES: z.string(),
    VUE_APP_ENABLE_USER_STATUSES: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_ENABLE_SYSTEM_WALLETS: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_DISABLE_EXCHANGE: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_AUT_FAVICON: z.string(),
    VUE_APP_AUT_FAVICON_APPLE: z.string(),
    VUE_APP_AUT_LOGO: z.string(),
    VUE_APP_AUT_LOGO_MOBILE: z.string(),
    VUE_APP_TITLE: z.string(),
    VUE_APP_PLATFORM: z.string(),
    VUE_APP_FACEBOOK_ENABLED: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_GOOGLE_ENABLED: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_TITLE_FOOTER: z.string(),
    VUE_APP_HEADER1: z.string(),
    VUE_APP_HEADER2: z.string(),
    VUE_APP_HEADER3: z.string(),
    VUE_APP_LAPTOP: z.string(),
    VUE_APP_SOCIAL_LINKS: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_LANDING_URL: z.string(),
    VUE_APP_SHOW_BLOCKSCAN: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_TERMS: z.string(),
    VUE_APP_RSS_RU_URL: z.string().optional(),
    VUE_APP_RSS_EN_URL: z.string(),
    VUE_APP_ENABLE_KYC_REQUIREMENT: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_HYPERLEDGER_FABRIC: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_KYC_VERIFF_KEY: z.string(),
    VUE_APP_ISSUER_REGISTRATION_DISABLED: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_GA_ID: z.string(),
    VUE_APP_PROJECT_TITLE_TYPE: z.string(),
    VUE_APP_ENABLE_ADVISER: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_VENDOR: z.string(),
    VUE_APP_ENABLE_REFERRAL_SYSTEM: z.preprocess(val => val === "true", z.boolean()),
    VUE_APP_MANIFEST_URL: z.string(),
    VUE_APP_RETAIL_USER_YEAR_LIMIT: z.string().optional(),
    VUE_APP_RETAIL_USER_PROJECT_LIMIT: z.string().optional(),
    NODE_ENV: z.enum(["development", "production", "test"]),
    BASE_URL: z.string()
}).strict(); // 👈 Вот магия — ошибка если есть поля НЕ из схемы
export const env = envSchema.parse(process.env);
